import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import '@shopify/polaris/build/esm/styles.css';
import './index.css';
import './i18n'; // Initialize i18next before rendering the app

// ✅ Official App Bridge setup (exact pattern from approved Geofy app)
function setupAppBridge() {
  const urlParams = new URLSearchParams(window.location.search);
  const host = urlParams.get('host') || window.SHOPIFY_HOST;
  const shop = urlParams.get('shop') || window.SHOPIFY_SHOP;
  
  // ✅ CRITICAL: Persist params in sessionStorage for navigation
  if (host) {
    sessionStorage.setItem('shopify_host', host);
    window.SHOPIFY_HOST = host;
  }
  if (shop) {
    sessionStorage.setItem('shopify_shop', shop);
    window.SHOPIFY_SHOP = shop;
  }
  
  // ✅ CRITICAL: Read API key from meta tag injected by server
  const metaApiKey = document.querySelector('meta[name="shopify-api-key"]')?.getAttribute('content');
  const apiKey = metaApiKey !== '%SHOPIFY_API_KEY%' ? metaApiKey : 
                 window.SHOPIFY_API_KEY || window.shopifyAppBridgeConfig?.apiKey;

  console.log('🔧 Setting up App Bridge:', { 
    host: !!host, 
    apiKey: !!apiKey,
    metaApiKey,
    shopifyKeys: Object.keys(window).filter(k => k.includes('SHOPIFY'))
  });

  if (!apiKey) {
    console.error('❌ Shopify API key not found');
    return;
  }

  if (host && apiKey) {
    // ✅ Dynamic import for better performance (Geofy pattern)
    import('@shopify/app-bridge').then(({ default: createApp }) => {
      import('@shopify/app-bridge/utilities').then(({ getSessionToken }) => {
        try {
          // ✅ App Bridge configuration matching Geofy
          const appBridgeConfig = {
            apiKey: apiKey,
            host: host,
            forceRedirect: true
          };

          // ✅ Create App Bridge instance
          const app = createApp(appBridgeConfig);
          window.appBridge = app;

          // ✅ Setup session token function (exact Geofy implementation)
          const setupSessionToken = async () => {
            try {
              window.getSessionToken = async () => {
                console.log('🎫 Getting session token...');
                const token = await getSessionToken(app);
                console.log('✅ Session token obtained');
                return token;
              };
              console.log('✅ Token function setup complete');
            } catch (error) {
              console.error('❌ Failed to setup session token:', error);
            }
          };

          setupSessionToken();
          console.log('✅ App Bridge setup complete');
        } catch (error) {
          console.error('❌ App Bridge setup failed:', error);
        }
      }).catch(error => {
        console.error('❌ Failed to import app-bridge utilities:', error);
      });
    }).catch(error => {
      console.error('❌ Failed to import app-bridge:', error);
    });
  } else {
    console.warn('⚠️ App Bridge setup skipped - missing host or API key');
  }
}

// Setup App Bridge after a short delay to ensure DOM is ready
setTimeout(setupAppBridge, 100);

// Render the React app
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);